// Scheduled Pickup
import {
  RECEIVE_CARRIER_PICKUP_SUBMIT,
  RECEIVE_FETCHING_CARRIER_PICKUP_DATA,
  RECEIVE_CARRIER_PICKUP_DATA_ERROR,
  RECEIVE_CARRIER_PICKUP_DATA,
  UPDATE_CARRIER_PICKUP_ADDRESS,
  UPDATE_CARRIER_PICKUP_DATE,
  UPDATE_CARRIER_PICKUP_SHOW_FORM,
  UPDATE_CARRIER_PICKUP_CANCEL_FORM,
  UPDATE_CARRIER_PICKUP_FORM_FIELD,
  UPDATE_CARRIER_PICKUP_FIELDS_MISSING,
  UPDATE_CARRIER_PICKUP_TIME_WINDOW,
} from '../../actions/carrierPickup';
import {
  NAVIGATION_TO_LANDING_PAGE,
  NAVIGATION_TO_STEP_1,
  UPDATE_ALL_STEPS_COMPLETE_STATUS,
} from '../../actions/page';

export const initialState = {
  carrier: null,
  date: null,
  address: {
    address_line1: null,
    address_line2: null,
    city: null,
    company_name: null,
    country: null,
    country_code: null,
    email: null,
    first_name: null,
    last_name: null,
    phone_number: null,
    postal_code: null,
    province: null,
  },
  form: {
    show: false,
    cancellable: true,
    layout: undefined,
    address: {
      address_line1: null,
      address_line2: null,
      city: null,
      company_name: null,
      country: null,
      country_code: null,
      email: null,
      first_name: null,
      last_name: null,
      phone_number: null,
      postal_code: null,
      province: null,
    },
    incompleteFields: [],
    touched: false,
  },
  pickupDates: [],
  isFetching: false,
  error: false,
};

export default (
  state = initialState,
  {
    type,
    data: {
      key,
      value,
      pickupInfo: {
        /* eslint-disable camelcase */
        first_name,
        last_name,
        address_line1,
        address_line2,
        city,
        company_name,
        country,
        country_code,
        email,
        phone_number,
        pickup_date: date,
        postal_code,
        province,
        /* eslint-enable camelcase */
      } = {},
      pickupForm: {
        pickupDates,
        address,
        pickupDate,
        pickupTimeZone,
        pickupTimeWindows,
        pickupTimeWindow,
        form = {},
        showPickupDates,
      } = {},
      isFetching,
      carrier,
    } = {},
  } = {},
) => {
  switch (type) {
    case RECEIVE_CARRIER_PICKUP_SUBMIT:
      return {
        ...state,
        date,
        address: {
          first_name,
          last_name,
          address_line1,
          address_line2,
          city,
          company_name,
          country,
          country_code,
          email,
          phone_number,
          postal_code,
          province,
        },
      };
    case RECEIVE_CARRIER_PICKUP_DATA:
      return {
        ...state,
        address,
        pickupDates,
        showPickupDates,
        form,
        isFetching,
        carrier,
      };
    case RECEIVE_FETCHING_CARRIER_PICKUP_DATA:
      return {
        ...state,
        isFetching,
      };
    case RECEIVE_CARRIER_PICKUP_DATA_ERROR:
      return {
        ...state,
        isFetching: false,
        error: true,
      };
    case UPDATE_CARRIER_PICKUP_ADDRESS:
      return {
        ...state,
        address,
        form: {
          address,
          show: false,
          cancellable: true,
          layout: state.form.layout,
          incompleteFields: [],
          touched: true,
        },
      };
    case UPDATE_CARRIER_PICKUP_DATE:
      return {
        ...state,
        date: pickupDate,
        timeZone: pickupTimeZone,
        timeWindows: pickupTimeWindows,
      };

    case UPDATE_CARRIER_PICKUP_TIME_WINDOW:
      return {
        ...state,
        timeWindow: pickupTimeWindow,
      };

    case UPDATE_CARRIER_PICKUP_SHOW_FORM:
      return {
        ...state,
        form: {
          ...state.form,
          show: form.show,
        },
      };

    case UPDATE_CARRIER_PICKUP_FORM_FIELD:
      return {
        ...state,
        form: {
          ...state.form,
          incompleteFields: state.form.incompleteFields.filter((field) => {
            if (field === key) {
              return !value;
            }
            return true;
          }),
          address: {
            ...state.form.address,
            [key]: value,
          },
        },
      };

    case UPDATE_CARRIER_PICKUP_CANCEL_FORM:
      return {
        ...state,
        form: {
          ...state.form,
          incompleteFields: [],
          address: state.form.touched ? state.form.address : { country: state.address.country },
          show: false,
        },
      };

    case UPDATE_CARRIER_PICKUP_FIELDS_MISSING:
      return {
        ...state,
        form: {
          ...state.form,
          incompleteFields: form.incompleteFields,
        },
      };

    case NAVIGATION_TO_LANDING_PAGE:
    case NAVIGATION_TO_STEP_1:
    case UPDATE_ALL_STEPS_COMPLETE_STATUS:
      return initialState;

    default:
      return state;
  }
};
